<template>
    <div>
        <!-- Upcoming events -->
        <div v-if="upcomingEvents.length">
            <div class="flex items-baseline justify-end p-4 lg:px-12 py-5 lg:py-3">
                <h2 class="text-3xl lg:text-5xl font-semi-bold text-right">{{ $t('events.upcoming') }}</h2>
            </div>
            <div v-for="(event, index) in upcomingEvents" :key="event.id">
                <MoleculeCardEvent :class="{ '!border-b-0': index + 1 !== upcomingEvents.length }" :event="event"/>
            </div>

        </div>

        <!-- Past events -->
        <MoleculePastEvent :events="events"/>

        <!-- Loader for next events -->
        <AtomLoading v-if="loadNext && !allIsLoad"/>
    </div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import moment from "moment";
import MoleculePastEvent from "../molecules/MoleculePastEvent.vue";
import MoleculeCardEvent from "../molecules/MoleculeCardEvent.vue";
import MoleculeCardEventSkeleton from "../molecules/MoleculeCardEventSkeleton.vue";
import TransitionFade from "../../../transitions/TransitionFade.vue";
import _ from "lodash";
import AtomLoading from "./AtomLoading.vue";

export default {
    name: "OrganismEvent",
    components: {AtomLoading, TransitionFade, MoleculeCardEventSkeleton, MoleculeCardEvent, MoleculePastEvent},
    data() {
        return {
            loadNext: false
        }
    },

    computed: {
        ...mapState('event', {
            events: 'events',
            allIsLoad: 'allIsLoad'
        }),

        ...mapGetters('event', {
            upcomingEvents: 'upcomingEvents',
        }),
        currentPeriod() {
            const currentDate = moment();
            const currentMonth = currentDate.format("MMM");
            const threeMonthsLater = currentDate.clone().add(3, "months").format("MMM");
            let year = currentDate.format("YYYY");

            // Check if three months later is in the next year
            if (moment(threeMonthsLater, "MMM").isBefore(currentDate, "month")) {
                year = `${year}-${String(parseInt(year) + 1).substring(2, 4)}`;
            }

            return `${currentMonth} - ${threeMonthsLater} ${year}`;
        }
    },

    methods: {
        ...mapActions('event', {
            loadNextEvents: 'loadMore'
        }),

        handleScroll: _.debounce(function () {
            // Check if you are at the bottom of the page
            if (window.scrollY + window.innerHeight + 500 >= document.body.scrollHeight) {
                this.loadNext = true
                this.loadNextEvents()
            }

            if (this.allIsLoad) {
                window.removeEventListener("scroll", this.handleScroll);
            }
        }, 200)
    },

    mounted() {
        window.addEventListener("scroll", this.handleScroll);
    },

    beforeDestroy() {
        window.removeEventListener("scroll", this.handleScroll);
    }
}
</script>

